import React from "react";
import PricingSection from "../../../components/PricingTableView/ProductPriceTable";
import styles from "./index.css";
import specificFaqs from '../../../data/wfmFaq.json'

const Page = () => {
  return (
    <>
      <div className="root">
        <div className="bg-sect" />
        <div className="pricing-sect">
          <PricingSection
            productShort={"wfm"}
            featuresLink="/workflow-manager"
            specificFaqs={specificFaqs}
          />
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

Page.getInitialProps = (ctx) => {
  return { noPadding: true };
};

export default Page;
